import { useState } from 'react'
import {
  Image,
  Stack,
  Text
} from '@chakra-ui/react'
import { ImagesPng } from 'assets/images'
import { QRCodeCanvas } from 'qrcode.react'
import { StyledButtonContainer } from 'common/Buttons/SingleButton/styled'
import { COLORS } from 'utils/styles'

export const WalletAddress = ({
  walletAddress,
  isAuth,
  handleSignUpModal
}) => {
  const [wallet, setWallet] = useState('Pay')
  const [showWalletAddressQR, setShowWalletAddressQR] = useState(0)
  const [showLogo, setShowLogo] = useState(1)
  const [disablePay, setDisablePay] = useState(false)

  const handleWallet = () => {
    if (walletAddress) {
      const tempShowWalletAddress = !showWalletAddressQR

      if (tempShowWalletAddress) {
        setTimeout(() => {
          setWallet('Copied to clipboard')
          setDisablePay(true)
          setShowWalletAddressQR(tempShowWalletAddress)
          navigator.clipboard.writeText(walletAddress)
          setShowLogo(0)

          setTimeout(() => {
            setDisablePay(false)
            setWallet('Close')
          }, 2000)
        }, 100)

        const ANIMATION_DURATION = 900
        const scrollStart = Date.now()
        const scrollInterval = setInterval(() => {
          requestAnimationFrame(() => {
            document.querySelector('#bottomBox')?.scrollIntoView({
              behavior: 'auto',
              block: 'end'
            })
          })

          if (Date.now() - scrollStart > ANIMATION_DURATION) {
            clearInterval(scrollInterval)
          }
        }, 0)
      } else {
        setShowWalletAddressQR(tempShowWalletAddress)

        setTimeout(() => {
          setShowLogo(1)
          setWallet('Pay')
        }, 800)
      }
    } else {
      setWallet('No wallet address connected')
      setShowLogo(0)

      setTimeout(() => {
        setWallet('Pay')
        setShowLogo(1)
      }, 2000)
    }
  }

  return (
    <Stack
      position="relative"
      paddingTop={showWalletAddressQR ? '235px' : 0}
      transition="0.8s ease"
      display="flex"
      alignItems="center"
      margin="0px 20px 10px 20px"
    >
      <Stack
        height={showWalletAddressQR ? '235px' : 0}
        width="100%"
        margin="20px auto"
        border={showWalletAddressQR ? 'solid 1px black' : ''}
        borderRadius="5px"
        padding={showWalletAddressQR ? '14px 0px 0px 0px' : 0}
        alignItems="center"
        transition="0.8s ease"
        overflow="hidden"
        position="absolute"
        top="-28px"
        boxShadow="0 4px 2px rgba(0, 0, 0, 0.1) !important"
      >
        <QRCodeCanvas value={walletAddress} size={160} />
        <Text
          textAlign="center"
          wordBreak="break-word"
          padding="0 10px"
          fontSize="16px"
          margin="0px !important"
        >
          {walletAddress}
        </Text>
      </Stack>

      <StyledButtonContainer
        id="profile-wallet-btn"
        name="profile-wallet"
        onClick={() => {
          if (isAuth()) {
            handleWallet()
          } else {
            handleSignUpModal()
          }
        }}
        style={{
          alignItems: 'center',
          width: '100%',
          minHeight: '35px',
          fontWeight: '500',
          backgroundColor: walletAddress === null || disablePay
            ? COLORS.semiLightGray
            : COLORS.gold,
          display: 'flex',
          pointerEvents: disablePay ? 'none' : 'auto',
          ...(!walletAddress && { backgroundColor: '#e6e6e6' })
        }}
      >
        {wallet}
        <Image
          width="20px"
          objectFit="cover"
          src={ImagesPng.Logo}
          alt="Logo"
          borderRadius="full"
          marginLeft="3px"
          display={showLogo ? 'flex' : 'none'}
        />
      </StyledButtonContainer>
    </Stack>
  )
}
